const translations: Record<string, string> = {
  "ak_docspage_contracts": "Договори",
  "ak_docspage_reporting": "Звітність",
  "ak_docspage_technical_documentation": "Технічна документація",
  "ak_docspage_regulatory_acts": "Нормативні акти",
  "ak_docspage_all": "Усі",
  "ak_docspage_monthly": "Місячні",
  "ak_docspage_quarterly": "Квартальні",
  "ak_docspage_annual": "Річні",
  "ak_docspage_the_legislation_registry_pages_respond": "Сторінки реєстру законодавства відповідають повільно — це їхній сервер. Документ можна відкрити в окремій вкладці кнопкою вгорі.",
  "ak_docspage_the_registry_currently_contains_only_a": "У реєстрі поки лише перелік документів. Перегляд і завантаження запрацюють, щойно файли привʼяжуть до обʼєкта.",
  "ak_docspage_of": "{{ok}} з {{total}}",
  "ak_docspage_download": "Завантажити",
  "ak_docspage_open_source": "Відкрити джерело",
  "ak_docspage_not_yet_concluded": "ще не укладено",
  "ak_docspage_not_applicable": "не застосовується",
  "ak_docspage_station_documents": "Документи станції",
  "ak_docspage_monthly_2": "місячна",
  "ak_docspage_quarterly_2": "квартальна",
  "ak_docspage_annual_2": "річна",
  "ak_docspage_no_file": "немає файла",
  "ak_docspage_select_a_document_from_the_list": "Оберіть документ зі списку",
  "ak_docspage_details_not_specified": "реквізити не вказані",
  "ak_docspage_preview_is_not_available_in_the_portal": "Перегляд у кабінеті недоступний",
  "ak_docspage_the_browser_cannot_display_spreadsheet": "Браузер не вміє показувати таблиці всередині сторінки. Файл можна завантажити.",
  "ak_docspage_loading_from_zakon_rada_gov_ua": "Завантажуємо з zakon.rada.gov.ua…",
  "ak_docspage_opening_the_document": "Відкриваємо документ…",
  "ak_docspage_file_not_uploaded_yet": "Файл ще не підвантажено",
  "ak_docspage_documents": "Документи",
  "ak_docspage_all_years": "Усі роки",
  "ak_docspage_there_are_no_contract_dates_in_the_reg": "Дат договорів у реєстрі ще немає — роки зʼявляться разом із ними.",
  "ak_docspage_search_documents": "Пошук документів…",
  "ak_docspage_a_z": "А → Я",
  "ak_docspage_z_a": "Я → А",
  "ak_docspage_nothing_found": "Нічого не знайдено.",
};

export default translations;
